import { format } from "rut.js";
import { columns } from "../../../../dtos/columns";
import inmobiliariaDto from "../models/inmobiliariaDto";
import CustomToolTip from "../../../../components/ui/customToolTip";
import AccionesInmobiliaria from "../components/accionesInmobiliaria";
import { InmobiliariaWriteDto } from "../components/inmobiliariaForm";

interface IProps {
  control: any;
  setInmobiliariaEditar: React.Dispatch<React.SetStateAction<InmobiliariaWriteDto | undefined>>;
  setModalDetalle: React.Dispatch<React.SetStateAction<boolean>>;
}

export function useColumns({ control, setInmobiliariaEditar, setModalDetalle }: IProps) {

  const COLUMNS: columns<inmobiliariaDto>[] = [
    {
      name: 'Acciones',
      selector: (row) => '',
      cell: (row) =>
        <AccionesInmobiliaria
          inmobiliaria={row}
          renderizar={() => control.fetchData()}
          setInmobiliariaEditar={setInmobiliariaEditar}
          setModalDetalle={setModalDetalle}
        />,
      allowOverflow: true,
      button: true,
      export: false,
      alling: 'center',
      width: "10%"
    },
    {
      name: 'Inmobiliaria',
      selector: (row) =>
        row.nombre,
      sortable: true,
      sortField: 'nombre',
      wrap: true,
      export: true,
      width: "25%"
    },
    {
      name: 'RUT inmobiliaria',
      selector: (row) =>
        format(row.rut),
      sortable: true,
      sortField: 'rut',
      wrap: true,
      export: true,
      width: "15%"
    },
    {
      name: 'Convenio vigente',
      selector: (row) => row.nombreConvenio,  // ← Retorna string para export
      cell: (row) =>                            // ← Renderiza JSX en tabla
        <CustomToolTip text={row.descripcionConvenio ?? ''}>
          <span>{row.nombreConvenio}</span>
        </CustomToolTip>,
      sortable: true,
      sortField: 'nombreConvenio',
      wrap: true,
      export: true,
      width: "15%"
    },
    {
      name: 'Holding',
      selector: (row) =>
        row.nombreHolding,
      sortable: true,
      sortField: 'nombreHolding',
      wrap: true,
      export: true,
      width: "25%"
    },
    {
      name: 'RUT holding',
      selector: (row) =>
        format(row.rutHolding),
      sortable: true,
      sortField: 'rutHolding',
      wrap: true,
      export: true,
      width: "15%"
    },
  ]

  return { COLUMNS };
}